/* Feedback-pop-up "Help ons met verbeteren!" (23-10-2026, tijdelijk, wens Jurri; ontwerp v5).
   - Iedereen, maximaal één keer per bezoeker (localStorage pbs_feedback), nooit bij afrekenen/account/bedankpagina.
   - Nooit tegelijk met de kortingspop-up (.pbs-pop): dan wachten tot die dicht is. Ook niet over de cookiebanner heen.
   - Computer: bij weggaan (muis naar de adresbalk/het kruisje).
   - Mobiel (geen seintje bij afsluiten): bij terugkomen na een andere app, bij 40 s stilzitten in configurator of
     winkelwagen, na het verlaten van de configurator zonder iets in de winkelwagen, of bij snel omhoog vegen.
   - Gebeurtenissen naar C.server: getoond, verstuurd (tekst), nee, kruisje, gesloten, concept (getypt, niet verstuurd).
   Instellingen en teksten: snippets/pbs-feedback.liquid (window.PBS_FEEDBACK). Kleuren via --fb-* (Bike kan ze wisselen). */
(() => {
  const C = window.PBS_FEEDBACK;
  if (!C || !C.server) return;
  if (C.tot && Date.now() > new Date(C.tot + 'T23:59:59').getTime()) return;
  const T = C.t;
  const lees = (k, s) => { try { return JSON.parse((s || localStorage).getItem(k)); } catch (e) { return null; } };
  const schrijf = (k, v, s) => { try { (s || localStorage).setItem(k, JSON.stringify(v)); } catch (e) { /* privémodus */ } };
  const pad = location.pathname.replace(/^\/(en|de|fr|es|it)(?=\/|$)/, '') || '/';
  if (/^\/(checkouts?|account|orders|tools)(\/|$)/.test(pad) || /thank_you|\/orders\//.test(location.pathname)) return;
  if (lees('pbs_feedback') && !/[?&]fbtest=1/.test(location.search)) return; // al eens getoond
  const cfgPad = (C.configurator || '/pages/naamsticker').replace(/^\/(en|de|fr|es|it)(?=\/)/, '').split('#')[0];
  const plek = pad.startsWith(cfgPad) || pad.startsWith('/pages/naamsticker') ? 'configurator' : /^\/cart(\/|$)/.test(pad) ? 'winkelwagen' : 'pagina';
  const mobiel = matchMedia('(pointer: coarse)').matches || innerWidth < 768;
  const id = Math.random().toString(36).slice(2) + Date.now().toString(36);
  const meld = (data, baken) => {
    const body = JSON.stringify(Object.assign({ taal: C.taal, land: C.land || '', plek, pad, apparaat: mobiel ? 'mobiel' : 'computer', id }, data));
    try {
      if (baken && navigator.sendBeacon) { navigator.sendBeacon(C.server, new Blob([body], { type: 'text/plain' })); return; }
      fetch(C.server, { method: 'POST', mode: 'cors', keepalive: true, headers: { 'Content-Type': 'text/plain' }, body }).catch(() => {});
    } catch (e) { /* niets */ }
  };

  let getoond = false;
  const bezet = () => document.querySelector('.pbs-pop') ||
    [...document.querySelectorAll('#shopify-pc__banner, .shopify-pc__banner__dialog')].some((b) => b.offsetParent !== null);
  const toon = (aanleiding) => {
    if (getoond) return;
    if (bezet()) { setTimeout(() => toon(aanleiding), 1000); return; }
    getoond = true;
    schrijf('pbs_feedback', { t: Date.now() });
    bouw(aanleiding);
  };

  function bouw(aanleiding) {
    const stijl = document.createElement('style');
    stijl.textContent = `
      .pbs-fb{--fb-bg:#e3f1fb;--fb-tekst:#0b2239;--fb-zacht:#4d6577;--fb-rand:#b7d3e8;--fb-knop:#0060b0;--fb-knop-tekst:#fff;--fb-x:#fff;--fb-dim:rgba(11,34,57,.45);
        position:fixed;inset:0;z-index:2147483001;display:flex;align-items:center;justify-content:center;font-family:Montserrat,"Segoe UI",Arial,sans-serif;color:var(--fb-tekst)}
      .pbs-fb__dim{position:absolute;inset:0;background:var(--fb-dim);animation:pbsFbIn .2s ease}
      .pbs-fb__kaart{position:relative;width:min(420px,calc(100vw - 32px));background:var(--fb-bg);border-radius:18px;box-shadow:0 24px 60px rgba(0,0,0,.4);padding:24px 26px 18px;text-align:center;animation:pbsFbOp .25s ease}
      .pbs-fb__x{position:absolute;top:10px;right:10px;width:30px;height:30px;border:0;border-radius:50%;background:var(--fb-x);color:var(--fb-tekst);font-size:19px;line-height:30px;padding:0;cursor:pointer}
      .pbs-fb h2{font-weight:800;font-size:20px;line-height:1.25;margin:2px 30px 6px}
      .pbs-fb p{font-size:13.5px;line-height:1.45;color:var(--fb-zacht);margin:0 0 12px}
      .pbs-fb input{width:100%;height:48px;border:1.5px solid var(--fb-rand);border-radius:10px;padding:0 14px;font:500 16px Montserrat,Arial,sans-serif;color:#1c1c1c;background:#fff;box-sizing:border-box}
      .pbs-fb input:focus{outline:none;border-color:var(--fb-knop)}
      .pbs-fb__knop{margin-top:10px;width:100%;height:48px;border:0;border-radius:10px;background:var(--fb-knop);color:var(--fb-knop-tekst);font:800 16px Montserrat,Arial,sans-serif;cursor:pointer}
      .pbs-fb__nee{display:inline-block;margin-top:10px;border:0;background:none;font:500 12.5px Montserrat,Arial,sans-serif;color:var(--fb-zacht);text-decoration:underline;cursor:pointer}
      .pbs-fb__hart{font-size:38px;line-height:1;margin:4px 0 6px}
      @keyframes pbsFbIn{from{opacity:0}}@keyframes pbsFbOp{from{opacity:0;transform:translateY(12px)}}
      @media (max-width:640px){.pbs-fb{align-items:flex-end}.pbs-fb__kaart{width:100%;border-radius:20px 20px 0 0;padding:20px 18px 16px;animation:pbsFbSchuif .3s ease}}
      @keyframes pbsFbSchuif{from{transform:translateY(100%)}}
      @media (prefers-reduced-motion:reduce){.pbs-fb__dim,.pbs-fb__kaart{animation:none}}`;
    document.head.appendChild(stijl);
    const e = (s) => String(s).replace(/[&<>"]/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]));
    const pop = document.createElement('div');
    pop.className = 'pbs-fb';
    pop.setAttribute('role', 'dialog');
    pop.setAttribute('aria-modal', 'true');
    pop.setAttribute('aria-labelledby', 'pbs-fb-titel');
    pop.innerHTML = `<div class="pbs-fb__dim"></div><div class="pbs-fb__kaart">
        <button type="button" class="pbs-fb__x" aria-label="${e(T.sluiten)}">×</button>
        <form novalidate><h2 id="pbs-fb-titel">${e(T.titel)}</h2><p>${e(T.tekst)}</p>
          <input type="text" name="tekst" maxlength="500" autocomplete="off" placeholder="${e(T.veld)}" aria-label="${e(T.veld)}">
          <button type="submit" class="pbs-fb__knop">${e(T.knop)}</button></form>
        <button type="button" class="pbs-fb__nee">${e(T.nee)}</button></div>`;
    document.body.appendChild(pop);
    meld({ e: 'getoond', aanleiding });
    const veld = pop.querySelector('input');
    if (!mobiel) setTimeout(() => veld.focus({ preventScroll: true }), 50);
    let klaar = false;
    const concept = (baken) => { const t = veld.value.trim(); if (t && !klaar) meld({ e: 'concept', tekst: t, aanleiding }, baken); };
    const weg = () => { pop.remove(); stijl.remove(); document.removeEventListener('keydown', toets); document.removeEventListener('visibilitychange', verborgen); };
    const sluit = (soort) => { if (!klaar) { concept(); meld({ e: soort, aanleiding }); } klaar = true; weg(); };
    const toets = (ev) => { if (ev.key === 'Escape') sluit('kruisje'); };
    // pagina weg terwijl de pop-up openstaat (tab dicht, andere app): tellen, en wat er al getypt was bewaren
    const verborgen = () => { if (document.visibilityState === 'hidden' && !klaar) { concept(true); meld({ e: 'gesloten', aanleiding }, true); klaar = true; } };
    document.addEventListener('keydown', toets);
    document.addEventListener('visibilitychange', verborgen);
    pop.querySelector('.pbs-fb__x').addEventListener('click', () => sluit('kruisje'));
    pop.querySelector('.pbs-fb__nee').addEventListener('click', () => sluit('nee'));
    pop.querySelector('.pbs-fb__dim').addEventListener('click', () => sluit('kruisje'));
    pop.querySelector('form').addEventListener('submit', (ev) => {
      ev.preventDefault();
      const t = veld.value.trim();
      if (!t) { veld.focus(); return; }
      klaar = true;
      meld({ e: 'verstuurd', tekst: t, aanleiding });
      pop.querySelector('.pbs-fb__kaart').innerHTML = `<button type="button" class="pbs-fb__x" aria-label="${e(T.sluiten)}">×</button>
        <div class="pbs-fb__hart">${e(T.hart)}</div><h2 id="pbs-fb-titel">${e(T.dank_titel)}</h2><p>${e(T.dank_tekst)}</p>`;
      pop.querySelector('.pbs-fb__x').addEventListener('click', weg);
      setTimeout(weg, 6000);
    });
  }

  // ---------- momenten ----------
  // testen: ?fbtest=1 in de adresbalk toont de vraag meteen
  if (/[?&]fbtest=1/.test(location.search)) { try { localStorage.removeItem('pbs_feedback'); } catch (e) { /* niets */ } setTimeout(() => toon('test'), 800); }
  // computer: muis verlaat het venster aan de bovenkant
  if (!mobiel) document.addEventListener('mouseout', (ev) => { if (!ev.relatedTarget && ev.clientY <= 5) toon('weggaan'); });
  // terugkomen na een andere app of tab (vooral mobiel)
  let wegSinds = 0;
  document.addEventListener('visibilitychange', () => {
    if (document.visibilityState === 'hidden') wegSinds = Date.now();
    else if (wegSinds && Date.now() - wegSinds > 3000 && mobiel) toon('terug');
  });
  // stilzitten in configurator of winkelwagen
  if (plek !== 'pagina') {
    let klok;
    const opnieuw = () => { clearTimeout(klok); klok = setTimeout(() => toon('stil'), 40000); };
    ['pointerdown', 'keydown', 'scroll', 'touchstart'].forEach((s) => addEventListener(s, opnieuw, { passive: true }));
    opnieuw();
  }
  // configurator verlaten zonder iets in de winkelwagen: vraag op de volgende pagina
  if (plek === 'configurator') schrijf('pbs_feedback_cfg', 1, sessionStorage);
  else if (lees('pbs_feedback_cfg', sessionStorage)) {
    try { sessionStorage.removeItem('pbs_feedback_cfg'); } catch (e) { /* niets */ }
    fetch('/cart.js', { credentials: 'same-origin' }).then((r) => r.json()).then((w) => { if (!w.item_count) setTimeout(() => toon('uit-configurator'), 1500); }).catch(() => {});
  }
  // mobiel: snel omhoog vegen na een eind naar beneden (richting adresbalk of terugknop)
  if (mobiel) {
    let vorige = scrollY, tijd = Date.now(), diepst = 0;
    addEventListener('scroll', () => {
      const nu = Date.now(), y = scrollY;
      diepst = Math.max(diepst, y);
      if (diepst > 800 && vorige - y > 250 && nu - tijd < 300 && y < 400) toon('omhoog');
      if (nu - tijd > 300) { vorige = y; tijd = nu; }
    }, { passive: true });
  }
})();
